// Remembers where a guest was heading when they hit the login wall, so they can
// be sent back there once the OTP flow finishes.
export const REDIRECT_PATH_COOKIE = "redirectPath";

export const setRedirectPath = (path) => {
  try {
    if (!path) {
      return;
    }
    document.cookie = `${REDIRECT_PATH_COOKIE}=${encodeURIComponent(path)}; path=/; max-age=1800`;
  } catch (error) {
    console.log(error);
  }
};

export const getRedirectPath = () => {
  try {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
      const [key, ...value] = cookie.split("=");
      if (key === REDIRECT_PATH_COOKIE) {
        // The path is encoded, so it can contain its own "=" characters
        return decodeURIComponent(value.join("=")) || null;
      }
    }
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const clearRedirectPath = () => {
  try {
    document.cookie = `${REDIRECT_PATH_COOKIE}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  } catch (error) {
    console.log(error);
  }
};
